<template>
  <section class="pageName">
    <h3 class="sup">{{ parentText }}</h3>
    <i class="fas fa-angle-double-right"></i>
    <h3 class="sub">{{ childText }}</h3>
  </section>
</template>

<script>
export default {
  name: 'PageTitle',
  data() {
    return {
      parentText: '',
      childText: ''
    }
  },
  watch: {
    $route: {
      handler() {
        // console.log('pageTitle : ', this.$route)
        if (this.$route.fullPath !== '/login') {
          this.getCurrentMenu()
        }
      }
    }
  },
  created() {
    // console.log(this.menuList)

    // console.log(this.parentText)
    // console.log(this.childText)

    this.getCurrentMenu()
  },
  methods: {
    getCurrentMenu() {
      // console.log('pageTitle ')
      // console.log(this.$route)
      const parentMenu = this.$route.matched[1].meta
      this.parentText = parentMenu.text
      this.childText = this.$route.meta.text
      console.log()
    }
  }
}
</script>

<style scoped>
.pageName {
  display: flex;
  padding:0 10px;
  align-items: center;
  /* border-bottom: 2px solid #7373734d; */
}
h2 {
  font-size: 1.3em;
  font-weight: 900;
}
.pageName i {
  font-weight: 900;
  margin: 8px 10px;
  color: #666;
}
.pageName h3:last-child {
  color: #666;
}
h3 {
  font-size: 14px;
  font-weight: 900;
  color: #9f9f9f;
}
</style>
